// src/components/atoms/Profile/Edit/DisplayNameLabel.js

import React from "react";
import { Typography, Grid } from "@mui/material";

const UserNameLabel = () => {
  return (
    <Grid item xs={12} sm={3} sx={{ textAlign: "right" }}>
      <Typography
        variant="body1"
        sx={{ fontFamily: "basic-sans", fontSize: "1em" }}
      >
        User Name
      </Typography>
    </Grid>
  );
};

export default UserNameLabel;
